
<script setup>

  import AudioPlayer from '../components/audio-player.vue';

  import audio_s1e7_210_310 from '../audio/s1e7_210_310.mp3';

  import track_s1e7_210_310 from '../audio/s1e7_210_310.vtt';

</script>

<template>

  <img class="block w-full max-w-[260px] mx-auto" src="../images/activity-2-part-1-food.png" alt="Three cans of Van Camp's Pork and Beans" />

  <p class="mt-6 text-neutral-700">
    
    Meals are important for road trips! Pack some extra "shoebox lunches" for your family.
    
    Miles down the road, you might not want to stop to eat in an unfamiliar area.
  
  </p>

  <div class="mt-6">

    <AudioPlayer :src="audio_s1e7_210_310" :track="track_s1e7_210_310" />
  
    <div class="mt-3 text-xs italic">Source: Driving the Green Book - Macmillan Podcasts - S1:E7</div>

  </div>

</template>
